import { connect } from 'react-redux';

import { triggerCamera } from '../../modules/nodes';
import TakePictureBtn from '../buttons/TakePictureBtn';

export default connect(
  null,
  (dispatch, ownProps) => ({ triggerCamera: (e) => {
    e.preventDefault();
    dispatch(triggerCamera(ownProps.id, 'image'))
  }})
)(TakePictureBtn);
